module.exports = "<div class=\"command\">\n\t<h5>Select a Device Command</h5>\n\t<div class=\"search-form\">\n\t\t<form action=\"\" class=\"form-horizontal\" name=\"searchForm\">\n\t\t\t<input type=\"search\" class=\"form-control\" name=\"searchText\" [ngModel]=\"(codeitem | async).searchText\"\n          (change)=\"searchTextChanged($event)\" placeholder=\"search for commands by name or keyword\">\n\t\t</form>\n\t</div>\n  <prg-list-selector></prg-list-selector>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/select-command/select-command.component.html
// module id = 1520
// module chunks = 2